class EnvironmentOM {
    static get init(): IEnvironmentOM {
        const env = window.environment || 'local';
        return this.environmentsOm[env];
    }

    static environmentsOm: { [key: string]: IEnvironmentOM } = {
        local: {
            production: false,
            pdauthURL: 'https://pddvgisweb.penndot.pa.gov/PDAUTH',
            isleBaseUrl: 'https://pddvgisweb.penndot.pa.gov/isle',
            mapcoreApi: window.location.origin + '/mapcore/api/',
            oneMapApi: 'https://localhost:5001/',
            oneMapURL: '//localhost:4202/',
            internalURLBase: 'https://pddvgisweb.penndot.pa.gov',
            basemapURL: 'https://gis.penndot.pa.gov/gis',
            layers: [
                { name: 'rmsseg', id: 1253 },
                { name: 'county', id: 1 },
                { name: 'district', id: 2 },
                { name: 'municipality', id: 3 },
                { name: 'planningPartner', id: 4 },
                { name: 'congressDistrict', id: 5 },
                { name: 'senateDistrict', id: 6 },
                { name: 'houseDistrict', id: 7 },
                { name: 'intersection', id: 2902 },
                { name: 'bridgesAll', id: 1592 },
                { name: 'mpmsProjectsAll', id: 2751 },
                { name: 'hopInternal', id: 2100 },
                { name: 'hopExternal', id: 7864 },
                { name: 'tmsSites', id: 2611 }
            ],
            titleAddition: ' - Local'
        },
        dev: {
            production: false,
            pdauthURL: 'https://pddvgisweb.penndot.pa.gov:8443/PDAUTH',
            isleBaseUrl: 'https://pddvgisweb.penndot.pa.gov/isle',
            mapcoreApi: window.location.origin + '/mapcore/api/',
            oneMapApi: EnvironmentOM.getBaseUrl(),
            oneMapURL: EnvironmentOM.getBaseUrl(),
            internalURLBase: 'https://pddvgisweb.penndot.pa.gov',
            basemapURL: 'https://gis.penndot.pa.gov/gis',
            layers: [
                { name: 'rmsseg', id: 1253 },
                { name: 'county', id: 1 },
                { name: 'district', id: 2 },
                { name: 'municipality', id: 3 },
                { name: 'planningPartner', id: 4 },
                { name: 'congressDistrict', id: 5 },
                { name: 'senateDistrict', id: 6 },
                { name: 'houseDistrict', id: 7 },
                { name: 'intersection', id: 2902 },
                { name: 'bridgesAll', id: 1592 },
                { name: 'mpmsProjectsAll', id: 2751 },
                { name: 'hopInternal', id: 2100 },
                { name: 'hopExternal', id: 7864 },
                { name: 'tmsSites', id: 2611 }
            ],
            titleAddition: ' - Development'
        },
        test: {
            production: true,
            pdauthURL: window.location.origin + '/PDAUTH',
            isleBaseUrl: 'https://pdstgisweb.penndot.pa.gov/isle/',
            mapcoreApi: window.location.origin + '/mapcore/api/',
            oneMapApi: EnvironmentOM.getBaseUrl(),
            oneMapURL: EnvironmentOM.getBaseUrl(),
            internalURLBase: 'https://pdstgisweb.penndot.pa.gov',
            basemapURL: 'https://gis.penndot.pa.gov/gis',
            layers: [
                { name: 'rmsseg', id: 1253 },
                { name: 'county', id: 1 },
                { name: 'district', id: 2 },
                { name: 'municipality', id: 3 },
                { name: 'planningPartner', id: 4 },
                { name: 'congressDistrict', id: 5 },
                { name: 'senateDistrict', id: 6 },
                { name: 'houseDistrict', id: 7 },
                { name: 'intersection', id: 2902 },
                { name: 'bridgesAll', id: 1593 },
                { name: 'mpmsProjectsAll', id: 2751 },
                { name: 'hopInternal', id: 9144 },
                { name: 'hopExternal', id: 7826 },
                { name: 'tmsSites', id: 2611 }
            ],
            titleAddition: ' - System Test'
        },
        prod: {
            production: true,
            pdauthURL: window.location.origin + '/PDAUTH',
            isleBaseUrl: 'https://pdprgisweb.penndot.pa.gov/isle/',
            mapcoreApi: window.location.origin + '/mapcore/api/',
            oneMapApi: EnvironmentOM.getBaseUrl(),
            oneMapURL: EnvironmentOM.getBaseUrl(),
            internalURLBase: 'https://pdprgisweb.penndot.pa.gov',
            basemapURL: 'https://gis.penndot.pa.gov/gis',
            layers: [
                { name: 'rmsseg', id: 1253 },
                { name: 'county', id: 1 },
                { name: 'district', id: 2 },
                { name: 'municipality', id: 3 },
                { name: 'planningPartner', id: 4 },
                { name: 'congressDistrict', id: 5 },
                { name: 'senateDistrict', id: 6 },
                { name: 'houseDistrict', id: 7 },
                { name: 'intersection', id: 2902 },
                { name: 'bridgesAll', id: 1592 },
                { name: 'mpmsProjectsAll', id: 2751 },
                { name: 'hopInternal', id: 9144 },
                { name: 'hopExternal', id: 7826 },
                { name: 'tmsSites', id: 2611 }
            ]
        }
    };

    static getBaseUrl() {
        return window.location.origin + (window.location.pathname.indexOf('/', 1) > -1 ? window.location.pathname.slice(0, window.location.pathname.indexOf('/', 1) + 1) : window.location.pathname);
    }
}

interface IEnvironmentOM {
    production: boolean;
    pdauthURL: string;
    isleBaseUrl: string;
    mapcoreApi: string;
    oneMapApi: string;
    oneMapURL: string;
    basemapURL: string;
    internalURLBase: string;
    layers: Array<{ name: string; id: number }>;
    titleAddition?: string;
}

export const environmentOm = EnvironmentOM.init;
